@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.order-import-mappings-delete-modal-body {
  padding: 15px;
  font-size: 13px;
  color: @order-import-mappings-delete-modal--text-color;
  min-height: 80px;
}

.button-group {
  margin-right: 5px;
}

.button-group button {
  margin: 5px;
}
